module.exports = __webpack_public_path__ + "img/zuijia_13.6944a85b.png";